<ng-container>
  <li [ngClass]="crumbClass">
    <a href="#" (click)="onCrumbClicked();" tabindex="-1">{{crumbLabel}}</a>
    
    <ng-container *ngIf="displayShortcuts; then shortcutTemplate"></ng-container>
  
  </li>
</ng-container>

<ng-template #shortcutTemplate>
  <div class="breadcrumbSubmenu">
  <h4>Switch to</h4>
  <ul>
    <ng-container *ngFor="let item of crumb.ShortcutItems">
      <li>
        <a href="#" (click)="onCrumbSiblingClicked(item);" tabindex="-1">{{item.value}}</a>
      </li>
    </ng-container>
  </ul>
</div>
</ng-template> 